import { type Component } from 'solid-js';
import Compare from '~/features/compare';

// Two or more funds held against each other. Full width — the whole page is one
// table whose columns are the funds, so every fund added needs a column's worth
// of room and there is nothing to put beside it.
const ComparePage: Component = () => (
    <div class='flex-1 min-w-0'>
        <Compare />
    </div>
);

export default ComparePage;
